/* Selector de variante en burbujas (colores con su color; tallas y demás como burbujas con texto)
   + se oculta con las ofertas que son packs (producto vinculado).
   También: la valoración y el aviso de urgencia se quedan en una sola línea, encogiendo el texto si no cabe. */
(function () {
  var COLORS = {
    verde: '#8cbf6a', green: '#8cbf6a', naranja: '#f5a55a', orange: '#f5a55a', azul: '#5b8def', blue: '#5b8def',
    rojo: '#e04b4b', red: '#e04b4b', rosa: '#f28cb6', pink: '#f28cb6', negro: '#222222', black: '#222222',
    blanco: '#ffffff', white: '#ffffff', gris: '#9aa0a6', grey: '#9aa0a6', gray: '#9aa0a6', amarillo: '#f2d14b',
    yellow: '#f2d14b', morado: '#9b6bd6', lila: '#b79be6', purple: '#9b6bd6', violeta: '#9b6bd6', beige: '#e6d5b8',
    crema: '#f3ead8', cream: '#f3ead8', marron: '#8b5e3c', 'marrón': '#8b5e3c', brown: '#8b5e3c', dorado: '#d4af37',
    gold: '#d4af37', plateado: '#c0c0c0', plata: '#c0c0c0', silver: '#c0c0c0', turquesa: '#3cc7c0', celeste: '#8fd3f4'
  };
  function colorFor(name) {
    var n = (name || '').toLowerCase().trim();
    if (COLORS[n]) return COLORS[n];
    var words = n.split(/[\s\/\-]+/);
    for (var i = 0; i < words.length; i++) if (COLORS[words[i]]) return COLORS[words[i]];
    return null;
  }
  function css() {
    if (document.getElementById('dv-swatch-css')) return;
    var s = document.createElement('style');
    s.id = 'dv-swatch-css';
    s.textContent =
      '.drevia-variant-picker.dv-has-swatches select{position:absolute!important;opacity:0!important;pointer-events:none!important;width:1px!important;height:1px!important}' +
      '.dv-swatches{display:flex;flex-wrap:wrap;gap:10px;align-items:center;margin:6px 0 2px}' +
      '.dv-swatch{width:30px;height:30px;border-radius:50%;border:2px solid #fff;box-shadow:0 0 0 1px rgba(0,0,0,.18);cursor:pointer;padding:0;position:relative;transition:transform .15s,box-shadow .15s,background .15s}' +
      '.dv-swatch:hover{transform:scale(1.06)}' +
      '.dv-swatch.is-active{box-shadow:0 0 0 2px var(--accent,#2f5e41)}' +
      '.dv-swatch.is-text{width:auto;min-width:46px;height:40px;border-radius:999px;padding:0 16px;background:#fff;border:2px solid #d6dce1;box-shadow:none;font:inherit;font-size:14px;font-weight:700;color:#20251f}' +
      '.dv-swatch.is-text.is-active{border-color:var(--accent,#2f5e41);background:color-mix(in srgb,var(--accent,#2f5e41) 12%,#fff);box-shadow:none}' +
      '.dv-swatch[disabled]{opacity:.35;cursor:not-allowed}' +
      '.drevia-variant-picker.dv-picker-hidden{display:none!important}';
    document.head.appendChild(s);
  }
  function build(picker) {
    var sel = picker.querySelector('select[data-variant-select]');
    if (!sel || picker.querySelector('.dv-swatches')) return;
    var opts = [].slice.call(sel.options);
    if (opts.length < 2) return;
    var wrap = document.createElement('div');
    wrap.className = 'dv-swatches';
    wrap.setAttribute('role', 'radiogroup');
    opts.forEach(function (o) {
      var name = o.text.split(' — ')[0].trim();
      var c = colorFor(name);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'dv-swatch' + (c ? '' : ' is-text');
      b.title = name;
      b.setAttribute('aria-label', name);
      b.dataset.value = o.value;
      if (c) b.style.background = c; else b.textContent = name;
      if (o.disabled) b.disabled = true;
      b.addEventListener('click', function () {
        sel.value = o.value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        sync(picker);
      });
      wrap.appendChild(b);
    });
    sel.insertAdjacentElement('afterend', wrap);
    picker.classList.add('dv-has-swatches');
    sel.addEventListener('change', function () { sync(picker); });
    sync(picker);
  }
  function sync(picker) {
    var sel = picker.querySelector('select[data-variant-select]');
    if (!sel) return;
    [].forEach.call(picker.querySelectorAll('.dv-swatch'), function (b) {
      var on = b.dataset.value === sel.value;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }
  function visibility() {
    var offer = document.querySelector('.drevia-offer.is-selected');
    var pack = !!(offer && offer.dataset.swapVariantId);
    [].forEach.call(document.querySelectorAll('.drevia-variant-picker'), function (p) {
      p.classList.toggle('dv-picker-hidden', pack);
    });
  }
  function init() {
    css();
    [].forEach.call(document.querySelectorAll('.drevia-variant-picker'), build);
    visibility();
    [].forEach.call(document.querySelectorAll('[data-offer]'), function (o) {
      if (o.__dvObs) return;
      o.__dvObs = new MutationObserver(visibility);
      o.__dvObs.observe(o, { attributes: true, attributeFilter: ['class'] });
    });
  }
  window.dvColorFor = colorFor;
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-offer]')) setTimeout(visibility, 0); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  ['shopify:section:load', 'shopify:block:select'].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(init, 50); }); });
})();

(function () {
  var SEL = '.drevia-rating__text, .drevia-urgency--dynamic .drevia-urgency__line, .drevia-guarantee--pill > span:not(.drevia-guarantee__icon), .drevia-guarantee--rounded > span:not(.drevia-guarantee__icon), .dv-cmp__brand-txt';
  function fit(el) {
    el.style.fontSize = '';
    if (!el.clientWidth) return;
    var base = parseFloat(getComputedStyle(el).fontSize), f = base, min = Math.max(8, base * 0.35);
    var r = document.createRange();
    function over() { r.selectNodeContents(el); return r.getBoundingClientRect().width > el.getBoundingClientRect().width + 0.01; }
    while (over() && f > min) { f -= 0.25; el.style.fontSize = f + 'px'; }
  }
  function all() { [].forEach.call(document.querySelectorAll(SEL), fit); }
  var t; function later() { clearTimeout(t); t = setTimeout(all, 60); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  window.addEventListener('load', all);
  window.addEventListener('resize', later);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(all);
  ['shopify:section:load', 'shopify:block:select', 'shopify:block:deselect'].forEach(function (ev) { document.addEventListener(ev, later); });
})();
